import Resizer from "react-image-file-resizer";

const WidthThreshold = 3840;
const HeightThreshold = 2160;

function LoadImage(image:File) : Promise<string> {
    return new Promise((resolve, reject) => {
        var render = new FileReader();
        render.readAsDataURL(image);
        render.onload = function() {
            resolve("");
        }
        render.onerror = function(e) {
            reject(e);
        }
    })
}


export function SizeCheck(image:File) {
    const fileImage = new Image();

    fileImage.src = window.URL.createObjectURL(image);
    fileImage.onload = function() {
        console.log(fileImage.naturalWidth);
        console.log(fileImage.naturalHeight);
    }
}

export function ResizeImage(image:File) : Promise<File | undefined>{
    const fileImage = new Image();

    return new Promise<File | undefined>((resolve, reject) => {
        fileImage.src = window.URL.createObjectURL(image);
        fileImage.onload = function() {

            const widthRatio = fileImage.naturalWidth / WidthThreshold;
            const heightRatio = fileImage.naturalHeight / HeightThreshold;

            if (widthRatio < 1.0 && heightRatio < 1.0) {
                resolve(image);
            }

            var setWidth;
            var setHeight;

            if (widthRatio >= heightRatio) {
                setWidth = WidthThreshold;
                setHeight = fileImage.naturalHeight / widthRatio;
            } else {
                setWidth = fileImage.naturalWidth / heightRatio;
                setHeight = HeightThreshold;
            }

            Resizer.imageFileResizer(
                image,
                setWidth,
                setHeight,
                "JPEG",
                100,
                0,
                function(uri) {
                    uri instanceof File ? resolve(uri) : resolve(undefined);
                },
                "file"
            )

        }
        fileImage.onerror = function(e) {
            reject(e);
        }
    })
    

}

export function GetImageSize(image:File) {

    return(
        LoadImage(image)
        .then(res => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = (e) => reject(e);
                img.src = res;
            });
        })
    );


    // return new Promise((resolve, reject) => {
    //     const img = new Image();
    //     img.onload = () => resolve(img);
    //     img.onerror = (e) => reject(e);
    //     img.src = image;
    //   });
}